// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__20V9w","logo":"Header_logo__25Tzm","operation":"Header_operation__2WF7K","black-bg":"Header_black-bg__2X2Kv"};